"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewport = void 0;
const react_1 = require("react");
const context_1 = require("../context");
/**
 * Return information related to the widget windows, and change function.
 * When windows changes, re-rendering is triggered.
 *
 * @returns
 *
 * ### Example
 * ```js
 * import { useViewport } from '@apitable/widget-sdk';
 *
 * // Full-screen display and control of the widget
 * function Viewport() {
 *   const { isFullscreen, toggleFullscreen } = useViewport();
 *   return (<div>
 *     <p>Widget expand full screen: {isFullscreen ? 'yes' : 'no'}</p>
 *     <button onClick={() => toggleFullscreen()}>Tap me to switch the widget to expand</button>
 *   </div>);
 * }
 * ```
 *
 */
function useViewport() {
    const { isFullscreen, toggleFullscreen } = (0, react_1.useContext)(context_1.WidgetConfigContext);
    return { isFullscreen, toggleFullscreen };
}
exports.useViewport = useViewport;
